import SimpleTable from 'components/Tables/SimpleTable';
import React from 'react';
import theme from 'source/theme';

const columns = [
  {
    title: 'Codigo MP',
    field: 'code',
    render: (value, row) => row.added_to_charge || row.mixture_id ? value : 'REACÇÃO'
  },
  {
    title: 'Nome Mistura/Substância',
    field: 'mixture_name',
    render: (value, row) => value === null || value === '' ? row.name : value
  }

];

// The only panel whose columns are not enough to order it. Both `render`s reach
// past their own field - the first draws `REACÇÃO` when the row is neither on
// the charge nor from a mixture, the second falls back to the substance's name
// when the mixture's is empty - so two rows equal in `code` and `mixture_name`
// can still draw different text. The fields they read are named here.
const ORDER = ['code', 'mixture_name', 'added_to_charge', 'mixture_id', 'name'];

export default props => {
  const { rowData, data, title } = props;

  const rows = data.filter(obj => obj.id === rowData.id);

  return (
    <div style={{ padding: 10, backgroundColor: theme.palette.background.light }}>
      <SimpleTable columns={columns} order={ORDER} rows={rows} title={title}/>
    </div>
  );
};
